import React from 'react';
import { noop } from 'lodash';
import classnames from 'classnames';
import { useBreakpoints } from '@fiverr-private/hooks';
import { PaperPlaneIcon, SpinnerAnimatedIcon } from '@fiverr-private/icons';
import { white } from '@fiverr-private/sass/helpers';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { Stack } from '@fiverr-private/layout_components';
import { useMonitoring } from '../../../../monitoring';
import styles from './index.module.scss';

const T_PREFIX = 'freelancer_page.contact';

export const ContactButtonDisplayComponent = ({
    isLoading,
    source,
    componentName,
    onClick = noop,
    buttonCopy,
    withGradient = false,
    ...buttonProps
}) => {
    const { sm: isSM } = useBreakpoints();
    const { handleClickContactButtonEvent } = useMonitoring();
    const handleClick = () => {
        onClick();
        handleClickContactButtonEvent({ source, componentName });
    };

    const buttonCopyIcon = !buttonCopy && <PaperPlaneIcon color={white} />;

    return (
        <Button
            {...buttonProps}
            onClick={handleClick}
            fullWidth
            className={classnames({ [styles.buttonWithGradient]: withGradient })}
        >
            <Stack alignItems="center" justifyContent="center" gap="2">
                {isLoading ? <SpinnerAnimatedIcon color={white} /> : buttonCopyIcon}
                {buttonCopy || <I18n k={isSM ? `${T_PREFIX}.button` : `${T_PREFIX}.contact`} />}
            </Stack>
        </Button>
    );
};
